import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'

export const Route = createFileRoute('/_booking/flightsmanyquery/results')({
  beforeLoad: ({ search }) => {
    throw redirect({ replace: true, search, to: '/vols-multi/resultats' })
  },
  validateSearch: z.object({ q: z.string().optional() }),
})
